/** Redirect non-active users to the active public campaign landing page, if one exists. */
export default defineNuxtRouteMiddleware((_to, from) => {
  const userStore = useUserStore();

  if (userStore.isActiveUser) return;

  const { activePublicCampaign } = useCampaigns();
  const localePath = useLocalePath();

  if (activePublicCampaign.value) {
    const slug = activePublicCampaign.value.code.toLowerCase();
    // Localized because an unprefixed path resets the active locale to the default one. The
    // `String` call is for typing only: `localePath` already resolves to a `fullPath` string.
    const landingPath = String(localePath(`/${slug}`));

    // Skip if already coming from this landing (e.g. it redirected away because it's disabled)
    if (from.path === landingPath) return;
    return navigateTo(landingPath);
  }
});
